export const CSRF_HEADER = 'x-xsrf-token';

export const PERSONALIZED_CAMPAIGNS_FIELDS =
    '(open_campaigns(name,campaign_id,showstopper_ids,tab_ids,ends_at,plus_ends_at,starts_at,delivery_promise,discount,images(upcoming,mobile,campaigns),options,has_logo,plus_early_access),showstoppers,tabs,upcoming_campaigns(name,campaign_id,discount,starts_at,images(upcoming),has_logo,plus_early_access))';
